if (!customElements.get('sky-main-cart')) {
  customElements.define(
    'sky-main-cart',
    class SkyMainCart extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick = (event) => {
        const removeButton = event.target.closest('[data-sky-cart-remove]');
        if (!removeButton || !this.contains(removeButton)) return;

        event.preventDefault();
        this.removeLine(removeButton);
      };

      async removeLine(button) {
        const line = Number(button.dataset.line);
        if (!line || button.disabled) return;

        button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        this.showError('');

        try {
          const sectionId = this.dataset.sectionId;
          const response = await fetch(window.routes.cart_change_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              line,
              quantity: 0,
              sections: [sectionId, 'cart-icon-bubble', 'cart-live-region-text'],
              sections_url: window.routes.cart_url,
            }),
          });

          const state = await response.json();
          if (!response.ok || state.errors) {
            throw new Error(typeof state.errors === 'string' ? state.errors : window.cartStrings.error);
          }

          this.replaceSection(sectionId, state.sections?.[sectionId]);
          this.replaceSection('cart-icon-bubble', state.sections?.['cart-icon-bubble']);
          this.replaceSection('cart-live-region-text', state.sections?.['cart-live-region-text']);

          if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sky-main-cart',
              cartData: state,
            });
          }
        } catch (error) {
          button.disabled = false;
          this.removeAttribute('aria-busy');
          this.showError(error.message || window.cartStrings.error);
        }
      }

      replaceSection(sectionId, html) {
        if (!html) return;
        const section = document.getElementById(`shopify-section-${sectionId}`);
        if (!section) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const renderedSection = parsed.getElementById(`shopify-section-${sectionId}`);
        section.innerHTML = renderedSection ? renderedSection.innerHTML : html;
      }

      showError(message) {
        const error = this.querySelector('[data-sky-cart-error]');
        if (!error) return;

        error.textContent = message;
        error.hidden = !message;
      }
    }
  );
}
